import styled from "styled-components";
import { Centered } from "../CardsStyled";

export const CenteredDescription = styled(Centered)`
  font-size: 16px;
`;
